import { SuretyAccountId } from "@inrev/common";
import { useAccountComments } from "@portal/api/comments";
import { messageDraftKey } from "@portal/components/features/message-draft";
import { CommentsSection } from "@portal/components/layout/CommentsSection";
import { FC } from "react";

type AccountCommentsSectionProps = {
	accountId: SuretyAccountId;
	accountDisplayName: string;
};

export const AccountCommentsSection: FC<AccountCommentsSectionProps> = ({
	accountId,
	accountDisplayName,
}) => {
	const { comments, commentsLoading, createComment, createCommentLoading } =
		useAccountComments(accountId);

	return (
		<div className="w-full z-[1]">
			<CommentsSection
				downloadTrackingId="account-agent-comments-download"
				entityType="Account"
				exportEntityType="account"
				comments={comments}
				commentsLoading={commentsLoading}
				createComment={createComment}
				createCommentLoading={createCommentLoading}
				draftKey={messageDraftKey("accounts", accountId)}
				commentDownloadHeader={`Account For ${accountDisplayName}`}
			/>
		</div>
	);
};
